import Vue from 'vue';

const namespaced = true;

const state = {
  itemProvinces: [],
  itemCities: [],
  itemStatus: [
    { value: true, text: 'form.active' },
    { value: false, text: 'form.noactive' }
  ],
  itemLanguage: [
    { value: 'en', text: 'English' },
    { value: 'in', text: 'Indonesia' }
  ],
  itemGenerate: [
    { value: 1, text: 'roles.parents' },
    { value: 2, text: 'roles.student' },
    { value: 3, text: 'roles.parent_student' }
  ],
  itemGender: [
    { value: 'Male', text: 'form.male' },
    { value: 'Female', text: 'form.female' }
  ],
  itemSchoolYears: [
    { value: '2019-2020', text: '2019-2020' },
    { value: '2020-2021', text: '2020-2021' },
    { value: '2021-2022', text: '2021-2022' }
  ]
};

const getters = {
  itemProvinces: state => state.itemProvinces,
  itemCities: state => (index = 0) => state.itemCities[index],
  itemStatus: state => state.itemStatus,
  itemLanguage: state => state.itemLanguage,
  itemGenerate: state => state.itemGenerate,
  itemGender: state => state.itemGender,
  itemSchoolYears: state => state.itemSchoolYears
};

const mutations = {
  SET_ITEM_PROVINCES: (state, payload) => {
    state.itemProvinces = payload;
  },
  SET_ITEM_CITIES: (state, { index, payload }) => {
    Vue.set(state.itemCities, index, payload);
  },
  RESET_CITIES: (state, index = 0) => {
    Vue.set(state.itemCities, index, []);
  }
};

const actions = {
  async fetchProvinces({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get('/api/province');
      commit('SET_ITEM_PROVINCES', data);
    } catch (err) {
      throw err;
    }
  },
  async fetchCities({ commit }, payload) {
    try {
      const index = Number.isInteger(payload) ? 0 : payload.index;
      const provinceId = Number.isInteger(payload) ? payload : payload.provinceId;
      const {
        data: { data }
      } = await window.axios.get(`/api/province/${provinceId}`);
      commit('SET_ITEM_CITIES', { index, payload: data });
    } catch (err) {
      throw err;
    }
  }
};

export default { namespaced, state, getters, mutations, actions };
